import {createSelector} from '@reduxjs/toolkit';

const dashboardsConfigurationStateSelector = (state) => state.dashboardsConfiguration;

export const selectordashboardConf = createSelector(
    dashboardsConfigurationStateSelector,
    (dashboardsState) =>dashboardsState.conf,
);

export const selectordashboardConfProp = createSelector(
    dashboardsConfigurationStateSelector,
    (configuration) => {
        const confProp = configuration && configuration.conf && configuration.conf.properties;
        let prop = undefined;
        if (confProp) {
            prop = confProp;
        }
        return prop;
    },
);

export const selectordashboardConfIds = createSelector(
    selectordashboardConfProp,
    (prop) => {
        if (prop) {
            return Object.keys(prop || {}).map(
                (id) => prop[id] && {...prop[id], idDash: id},
            );
        }
        return;
    },
);

export const selectorDate = createSelector(
    dashboardsConfigurationStateSelector,
    ( {
        startDate,
        endDate,
    }) => {
        return {
            startDate,
            endDate,
        };
    },
);

